<template>
  <div class="pk-videothumbnail-container"
   ref="container">
    <div class="pk-videothumbnail-items">
      <div v-for="(it,i) in items" class="pk-videothumbnail-item"
       :key="'tn' + i"
       :class="activeSlide.activeVideoKey === i ? 'showing' : ''"
       @click="selectVideoByIdx(i)"
      >
        <!-- <canvas :id="'video-thumbanil-' + i"></canvas> -->
        <div class="pk-videothumbnail-item-title">{{it.originalName}}</div>
      </div>
      <div v-if="items.length < 1">no videos found</div>
    </div>
    <!-- <div class="pk-videothumbnail-toolbar pk-flex__h-center">
      <img class="pk-videothumbnail-toolbar-img" src="../../assets/icons/first.svg"
       @click="toLeft">
      <img class="pk-videothumbnail-toolbar-img" :style="'opacity:'+(thumbnailIdx > 0 ? '1' : '0.4')"
       src="../../assets/icons/previous.svg"
       @click="selectImgByIdx(-1)">
      <img class="pk-videothumbnail-toolbar-img" :style="'opacity:'+(thumbnailIdx < items.length - 1 ? '1' : '0.4')"
       src="../../assets/icons/next.svg"
       @click="selectImgByIdx(1)">
      <img class="pk-videothumbnail-toolbar-img" src="../../assets/icons/last.svg"
       @click="toRight">
    </div> -->
  </div>
</template>

<script>
import Vue from 'vue';
import * as $ from 'jquery';

export default Vue.extend({
  props: {
    items: Array,
    colCount: Number,
    rowCount: Number
  },
  data() {
    return {
      selectedItem: null,
      parentHeight: 100,
      parentWidth: 100,
    };
  },
  // created() {},
  mounted() {
    const vue = this;

    const resize = () => {
      vue.parentHeight = $(vue.$refs.container).height();
      vue.parentWidth = $(vue.$refs.container).width();
    };
    window.addEventListener('resize', () => {
      resize();
    });
    resize();
  },
  // updated() {},
  watch: {
    // items() {
    //   for (let i = 0; i < this.items.length; i++) {
    //     // 
    //   }
    // }
  },
  computed: {
    thumbnailIdx() {
      const idx = this.$route.query['videothumbnail'];
      return parseInt(idx, 10) ? parseInt(idx, 10) : 0;
    },
    viewNavItems() {
      return this.$store.getters['archive/viewNavItems'];
    },
    activeSlide() {
      return this.$store.getters['archive/activeSlide'];
    },
  },
  methods: {
    selectVideoByIdx(i) {
      this.activeSlide.activeVideoKey = i;
    }
  }
});
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variable.scss';
@import '../../assets/scss/layout.scss';
@import '../../assets/scss/color.scss';
@import '../../assets/scss/size.scss';

.pk-videothumbnail-container {
  width: 100%;
  height:100%;
  overflow: auto;
}
.pk-videothumbnail-items {
  @extend .pk-flex;
  flex-direction: column;
  .pk-videothumbnail-item {
    margin: 2px;
    width: calc(100% - 4px);
    color: rgb(65, 130, 184);
    border-radius: 3px;
  }
  .showing {
    background-color: rgb(96, 136, 168);
    color: rgb(255, 255, 255);
  }
  .pk-videothumbnail-item:hover {
    background-color: rgb(39, 93, 138);
    color: rgb(199, 199, 199);
  }
}
.pk-videothumbnail-item-title {
  margin-left: 3px;
  cursor: pointer;
}
.pk-videothumbnail-toolbar-img {
  margin: 25px;
  height: 25px;
}
.pk-videothumbnail-toolbar-img:hover {
  margin: 25px;
  height: 25px;
  background-color: #eee;
  cursor: pointer;
}

/* .pk-videothumbnail-toolbar {} */

.pk-videothumbnail-toolbar img:hover {
  border: 1px solid #eee;
}

</style>
